module.exports = __webpack_public_path__ + "static/img/tenor.7bcd967.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tenor.gif
// module id = hP7o
// module chunks = 25